import { AuditLogEntry } from '../types';

/**
 * Creates a new audit log entry
 */
export const createAuditLog = (
  userId: string,
  userName: string,
  action: AuditLogEntry['action'],
  entityType: AuditLogEntry['entityType'],
  entityId: string,
  description: string,
  changes?: AuditLogEntry['changes']
): AuditLogEntry => {
  return {
    id: `log_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    timestamp: new Date().toISOString(),
    userId,
    userName,
    action,
    entityType,
    entityId,
    changes,
    description,
  };
};

/**
 * Format timestamp for display
 */
export const formatAuditTimestamp = (timestamp: string): string => {
  const date = new Date(timestamp);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

/**
 * Get color for action type
 */
export const getActionColor = (action: AuditLogEntry['action']): string => {
  switch (action) {
    case 'created':
      return 'bg-green-100 text-green-700';
    case 'updated':
      return 'bg-blue-100 text-blue-700';
    case 'deleted':
      return 'bg-red-100 text-red-700';
    case 'viewed':
      return 'bg-slate-100 text-slate-700';
    default:
      return 'bg-gray-100 text-gray-700';
  }
};

/**
 * Format file size for display
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};
